import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Col from 'reactstrap/lib/Col';
import { IHistory } from '../../interfaces';
import { CertificateModel } from '../../model/CertificateModel';
import { UserModel } from '../../model/UserModel';
import { userUniqueID } from '../../utils/generalUtils';
import './certificatePage.scss';
import { generateCertificateFromHTML } from '../../services/moduleService';
import { getUsersByLevel } from '../../services/userService';
// import { FaCertificate } from "react-icons/fa";
const certificate = require('../../images/certificate_icon.jpg');
import * as ReactDOM from 'react-dom';
import { Loader } from '../reusableComponents/Loader/Loader';

export interface IListItemProps {
    instance?: CertificateModel;
    userInstance: UserModel;
    index?: number;
    listItemProp?: string;
    onClick?: Function;
    className?: string;
    history?: IHistory;
}

interface IListItemState {
    open: boolean;
    downloading: boolean;
}

export class ListItemImpl extends React.PureComponent<IListItemProps, IListItemState> {
    constructor(props: IListItemProps) {
        super(props);
        this.state = { open: false, downloading: false };
    }

    private loaderContainer: HTMLDivElement | null = null;
    private loaderElement: HTMLDivElement | null = null;

    //  Show Loader method
    private showLoader = () => {

        if (this.loaderContainer) {
            this.hideLoader();
        }

        this.loaderContainer = document.createElement('div');
        this.loaderContainer.id = 'certificate-loader';
        this.loaderContainer.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 99999;
            display: flex;
            justify-content: center;
            align-items: center;
            background: rgba(0, 0, 0, 0.5);
        `;
        document.body.appendChild(this.loaderContainer);

        this.loaderElement = document.createElement('div');
        this.loaderElement.id = 'loader-content';
        this.loaderContainer.appendChild(this.loaderElement);

        ReactDOM.render(
            React.createElement(Loader, { type: "async" }),
            this.loaderElement
        );
    };

    //  Hide Loader method
    private hideLoader = () => {
        if (this.loaderElement) {
            ReactDOM.unmountComponentAtNode(this.loaderElement);
            this.loaderElement = null;
        }
        if (this.loaderContainer) {
            document.body.removeChild(this.loaderContainer);
            this.loaderContainer = null;
        }
    };

    handleDownloadPDF = async (e: React.MouseEvent) => {
        e.stopPropagation();
        const { instance, userInstance } = this.props;
        if (!instance) return;

        this.setState({ downloading: true });

        this.showLoader();

        try {
            const props = instance.props;
            const userName = props.userName || 'User';  
            const trainingName = props.moduleName || 'Training';
            const completionDate = props.dateCreated ? new Date(props.dateCreated) : new Date();
            let dd = String(completionDate.getDate()).padStart(2, '0');
            let mm = String(completionDate.getMonth() + 1).padStart(2, '0');
            const yyyy = completionDate.getFullYear();
            const date = mm + '/' + dd + '/' + yyyy;

            const certNo = `LMS-ENV-${yyyy}-${String(Math.floor(Math.random() * 10000)).padStart(4, '0')}`;

            let directorName = '';

            try {
                const response = await getUsersByLevel();


                const l2User = response;

                directorName = l2User
                    ? `${l2User.FirstName || ''} ${l2User.LastName || ''}`.trim()
                    : '';

            } catch (error) {
                console.error("Failed to fetch L2 user:", error);
                directorName = '';
            }

            await generateCertificateFromHTML({
                NAME: userName,
                COURSE: trainingName,
                EXAM: trainingName,
                CERTIFICATE: certNo,
                CERTIFICATE_NO: certNo,
                DATE: date,
                CERTIFICATE_LINK: instance.props.certificateLink,
                PROGRAM_DIRECTOR: directorName
            });

            this.hideLoader();

        } catch (error) {
            this.hideLoader();
            console.error('PDF Generation Failed:', error);
            alert('Failed to generate certificate. Please try again.');
        } finally {
            this.setState({ downloading: false });
        }
    };

    public render() {
        const { instance, userInstance, history, index } = this.props;
        const { downloading } = this.state;
        const isAdmin = UserModel.isAdmin(userInstance);
        return <div className="list-item" onClick={this.handleDownloadPDF}
            style={{
                cursor: downloading ? 'wait' : 'pointer',
                opacity: downloading ? 0.6 : 1
            }}>
            <Col className="serial-no center" sm={1} >{index}</Col>
            {isAdmin ? <Col className="name certificate-name" sm={2} >{instance.props.userName}</Col> : ''}
            {/* {isAdmin ? <Col className="modulename" sm={4} >{instance.props.moduleName}</Col> : ''} */}
            <Col className="modulename" sm={isAdmin ? 2 : 3} >{instance.props.moduleName ? instance.props.moduleName : ''}</Col>
            {/* {isAdmin ? '' : <Col className="space" sm={2} >{instance.props.dateCreated}</Col>} */}
            <Col className="category" sm={isAdmin ? 2 : 3} >{instance.props.category}</Col>
            <Col className="date submitted-date" sm={isAdmin ? 2 : 3} >{instance.props.dateCreated}</Col>
            <a target="_blank" href={instance.props.certificateLink} onClick={(e) => e.stopPropagation()} >
                <Col className={isAdmin ? "link" : "links"} sm={isAdmin ? 2 : 2} >
                    {/*{isAdmin ? `${instance.props.certificateName.substr(0, 40)}...` : instance.props.certificateName}*/}
                    {/* {instance.props.certificateName} */}
                    {/* <FaCertificate /> */}
                    <img className="certificate" alt={'brand-logo'} src={certificate} />

                </Col>
            </a>
        </div >;
    }
}

export function mapStateToProps(state) {
    return {
        userInstance: UserModel.get(userUniqueID(state))
    };
}

export const ListItem = withRouter(connect<{}, {}, IListItemProps>(mapStateToProps)(ListItemImpl) as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CertificatePages/ListItem.tsx